import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { FlexLayoutModule } from "@angular/flex-layout";
import { MatSelectModule } from "@angular/material/select";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatRadioModule } from "@angular/material/radio";
import { MatMenuModule } from "@angular/material/menu";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { CdkTableModule } from "@angular/cdk/table";
import { MatIconModule } from "@angular/material/icon";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTabsModule } from "@angular/material/tabs";

import { TruncatePipe } from "./pipes/truncate.pipe";
import { SplitPipe, CamlCasePipe, PascalCasePipe } from "./pipes/splitString.pipe";
import { KeysPipe } from "./pipes/keys.pipe";

import { DialogComponent } from "./components/dialogs/dialog.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { AlertComponent } from "./components/alert/alert.component";
import { SpinnerComponent } from "./components/spinner/spinner.component";
import { SearchFieldComponent } from "./components/search-field/search-field.component";
import { ReactiveFormsModule } from "@angular/forms";
// translator component
import { SortByPipe } from './pipes/sort.pipe';
import { PdfViewerModule } from "ng2-pdf-viewer";

import {
  MenuService,
  DialogsService,
  LoadingService,
  AuthCookie,
  LocalStorageService,
  MessageService,
  ApiService
} from "../shared//services/index.service";
import { StoreModule } from '@ngrx/store';
import { commonReducers } from './store/reducers';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AddressSuggestionComponent } from './components/address-suggestion/address-suggestion.component';
import { DisplayCellComponent } from './components/display-cell/display-cell.component';
import { GridService } from './services/grid.service';
import { OTPService } from './services/otp/otp.service';
import { OtpGuard } from './services/otp/otp.guard';
import { TranslocoSpinnerComponent } from "./translation/transloco-spinner.component";
import { TranslocoModule, TRANSLOCO_LOADING_TEMPLATE } from "@ngneat/transloco";
import { TranslocoRootModule } from "./translation/transloco-root.module";
import { NGTdsModule } from "@tesla/ng-tds";
import { SidePanelDialogComponent, SidePanelDialogContentComponent }  from './components/side-panel-dialog/side-panel-dialog.component';
import { FileViewerComponent } from './components/file-viewer/file-viewer.component';
import { TranslModule } from "./translation/transl/transl.module";
import { NgDynamicFormModule } from "@tesla/ng-dynamic-form";
import dynamicFormConfig from "./config/dynamic-form.config";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatInputModule,
    MatRadioModule,
    CdkTableModule,
    MatMenuModule,
    MatTableModule,
    MatButtonModule,
    MatSortModule,
    MatIconModule,
    MatTooltipModule,
    MatSidenavModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature('SharedModuleState', commonReducers),
    MatDialogModule,
    NGTdsModule,
    TranslocoModule,
    TranslocoRootModule,
    PdfViewerModule,
    TranslModule,
    NgDynamicFormModule.forRoot(dynamicFormConfig),
  ],
  declarations: [
    LoaderComponent,
    DialogComponent,
    SpinnerComponent,
    SearchFieldComponent,
    AlertComponent,
    ConfirmationComponent,
    AddressSuggestionComponent,
    TruncatePipe,
    SplitPipe,
    KeysPipe,
    CamlCasePipe,
    PascalCasePipe,
    DisplayCellComponent,
    SortByPipe,
    TranslocoSpinnerComponent,
    SidePanelDialogContentComponent,
    SidePanelDialogComponent,
    FileViewerComponent
  ],
  entryComponents: [
    AddressSuggestionComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatInputModule,
    MatRadioModule,
    MatMenuModule,
    CdkTableModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTabsModule,
    FlexLayoutModule,
    LoaderComponent,
    SearchFieldComponent,
    AlertComponent,
    ConfirmationComponent,
    AddressSuggestionComponent,
    SpinnerComponent,
    TruncatePipe,
    SplitPipe,
    KeysPipe,
    CamlCasePipe,
    PascalCasePipe,
    DisplayCellComponent,
    SortByPipe,
    NGTdsModule,
    TranslocoModule,
    TranslocoRootModule,
    TranslocoSpinnerComponent,
    SidePanelDialogContentComponent, 
    SidePanelDialogComponent,
    PdfViewerModule,
    FileViewerComponent,
    TranslModule,
    NgDynamicFormModule,
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        {
          provide: TRANSLOCO_LOADING_TEMPLATE,
          useValue: TranslocoSpinnerComponent,
        },
        MenuService,
        DialogsService,
        LoadingService,
        AuthCookie,
        LocalStorageService,
        MessageService,
        OTPService,
        OtpGuard,
        ApiService,
        GridService,
        DatePipe,
        TruncatePipe
      ]
    };
  }
}
